var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStarCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3359 6C27.3359 5.46957 27.1252 4.96086 26.7502 4.58579C26.3751 4.21071 25.8664 4 25.3359 4H21.3359V2H19.3359V4H11.3359V2H9.33594V4H5.33594C4.8055 4 4.2968 4.21071 3.92172 4.58579C3.54665 4.96086 3.33594 5.46957 3.33594 6V26C3.33594 26.5304 3.54665 27.0391 3.92172 27.4142C4.2968 27.7893 4.8055 28 5.33594 28H9.33594V26H5.33594V6H9.33594V8H11.3359V6H19.3359V8H21.3359V6H25.3359V12H27.3359V6Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3359 15L22.8849 19.938L28.3359 20.729L24.3359 24.573L25.3359 30L20.3359 27.438L15.3359 30L16.3359 24.573L12.3359 20.729L17.9359 19.938L20.3359 15Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarCalendar);
export default __webpack_public_path__ + "static/media/ic-star-calendar.5e55ae594cc04d170f70dbcd5bf9c47b.svg";
export { ForwardRef as ReactComponent };